.input {
  min-height: 0;
}

.input::placeholder {
  color: inherit;
}
